import React from "react";
import OverallScoreTab from "./OverallScoreTab.comp";
import ScoreByAgeTab from "./ScoreByAgeTab.comp";
import ScoreByGradeLevelTab from "./ScoreByGradeLevelTab.comp";
import ScoreByClassTab from "./ScoreByClassTab.comp";

// Props: processedRubricSchool, assessIndicators, selectedCategory, setSelectedCategory, monthRange, setMonthRange
export function getSchoolScoreTabs(
    processedRubricSchool,
    assessIndicators,
    selectedCategory,
    setSelectedCategory,
    monthRange,
    setMonthRange
) {
    return [
        {
            key: "overall",
            label: "OVERALL PERFORMANCE",
            path: "overall",
            component: <OverallScoreTab overall={processedRubricSchool.overall} />,
        },
        {
            key: "by_age",
            label: "BY AGE",
            path: "by_age",
            component: (
                <ScoreByAgeTab
                    byAgeData={processedRubricSchool.byAge}
                    assessIndicators={assessIndicators}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    monthRange={monthRange}
                    setMonthRange={setMonthRange}
                />
            ),
        },
        {
            key: "by_level",
            label: "BY GRADE LEVEL",
            path: "by_level",
            component: (
                <ScoreByGradeLevelTab
                    byLevelData={processedRubricSchool.byLevel}
                    assessIndicators={assessIndicators}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    monthRange={monthRange}
                    setMonthRange={setMonthRange}
                />
            ),
        },
        {
            key: "by_class",
            label: "BY CLASS",
            path: "by_class",
            component: (
                <ScoreByClassTab
                    byClassData={processedRubricSchool.byClass}
                    assessIndicators={assessIndicators}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    monthRange={monthRange}
                    setMonthRange={setMonthRange}
                />
            ),
        },
    ];
}
